import Api from './Api'

const END_POINT = 'products'

export default {
    async get_all (filters) {
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}`, request);
    },
    getSummary(product_id = null) {
        let request = {
            params: {
                product_id
            }
        }
        return Api.get(`${END_POINT}/summary`, request)
    },
    async get_list (filters) {
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}/list`, request);
    },
    store(product) {
        return Api.post(`${END_POINT}`, product);
    },
    get_product (product_id) {
        return Api.get(`${END_POINT}/${product_id}`);
    },
    update(product) {
        return Api.patch(`${END_POINT}/${product.id}`, product);
    },
    getCatalogue(filters) {
        let request = {
            params: filters
        }
        return Api.get(`${END_POINT}/catalogue`, request);
    },
    destroyProduct(product) {
        return Api.delete(`${END_POINT}/delete-product/${product.id}`, product);
    },
}